<template>
  <div class="layout-padding layout-padding--full-height flex justify-center items-center">
    <div class="bg-white">
      <new-team-stepper ref="newTeamStepper" @close="redirect"/>
    </div>
  </div>
</template>

<script>
  import NewTeamStepper from 'components/Team/Create/NewTeamStepper.vue'
  import { mapActions } from 'vuex'

  export default {
    meta () {
      return {
        title: this.$t('product_name')
      }
    },

    methods: {
      ...mapActions(['changeTeam']),

      redirect (team) {
        if (team) {
          this.changeTeam(team.id)
            .then((team) => {
              this.$router.push({ name: 'dashboard', params: { 'teamId': team.id } })
            })
        }
      }
    },

    components: {
      NewTeamStepper
    }
  }
</script>
